import { render, staticRenderFns } from "./StatisticsTemplateForTopic.vue?vue&type=template&id=44c2f1cf&"
import script from "./StatisticsTemplateForTopic.vue?vue&type=script&lang=js&"
export * from "./StatisticsTemplateForTopic.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTemplateForTopic.vue?vue&type=style&index=0&id=44c2f1cf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports